import {FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl} from '@angular/forms';
import {FormValidator} from "../validators/form.validator";

export class RegisterValidation {

  static createRegisterForm(fb: FormBuilder): FormGroup {
    return fb.group({
      name: ['', [FormValidator.requiredField('First name is required.'), Validators.pattern(/^(?!.*--)(?!.*'')(?!.*-.*-)(?!.*'.*')[a-zA-Z-' ]+$/)]],
      last_name: ['', [FormValidator.requiredField('Last name is required.'), Validators.pattern(/^(?!.*--)(?!.*'')(?!.*-.*-)(?!.*'.*')[a-zA-Z-' ]+$/)]],
      email: ['', [FormValidator.requiredField('Email is required.'), Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      password: ['', [FormValidator.requiredField('Password is required.'), Validators.minLength(8), this._customPasswordValidator()]],
      job_role: ['C', FormValidator.requiredField('Job role is required.')],
      country_of_residence: ['', FormValidator.requiredField('Country of residence is required.')],
      rcvs: ['', [Validators.minLength(7), Validators.maxLength(7), Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      job_types_other: [''],
      agreeTerms: [false],
      consent_third_party_sharing: [false]
    });
  }

    private static _customPasswordValidator(): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } | null => {
        const password = control.value;
        // Check if password has at least 8 characters without counting starting or ending spaces
        if (password.trim().length < 8) {
          return {minlength: true};
        }
        return null; // Return null if validation passes
      };
    }
}
